import { useCallback } from 'react'
import { useEndActiveSessionMutation } from 'src/app/appApiQueries'
import { setType } from 'src/app/modal'
import { useAppDispatch } from 'src/hooks'
import ModalTitle from '../ModalTitle'
import ModalButtons from '../ModalButtons'
import useModalLoading from 'src/hooks/useModalLoading'

export const SessionEndModal = () => {
  const [endActiveSession, { isLoading, isSuccess, isError }] =
    useEndActiveSessionMutation()
  const dispatch = useAppDispatch()
  useModalLoading({ isLoading, isSuccess, isError })

  const onEndSession = useCallback(() => {
    endActiveSession()
  }, [endActiveSession])

  const onCancel = () => {
    dispatch(setType({ type: null }))
  }

  return (
    <div>
      <ModalTitle styles="font-bold" text="End Session" />

      <p className="text-base">
        This session will be saved as read-only in All Sessions
      </p>

      <ModalButtons
        firstButton={{
          name: 'Cancel',
          type: 'secondary',
          onClick: onCancel,
          htmlButtonType: 'button',
        }}
        secondButton={{
          name: 'End',
          type: 'warning',
          onClick: onEndSession,
          htmlButtonType: 'button',
        }}
      />
    </div>
  )
}

export default SessionEndModal
